module.exports = __webpack_public_path__ + "img/Yanli_Ji@2x.11c152fe.png";